import { POST_NO_SHOW_BOOKING_LOADING, POST_NO_SHOW_BOOKING_FAILED, POST_NO_SHOW_BOOKING_SUCCESS, POST_NO_SHOW_BOOKING_RESET } from "../types"

const initialState = {
  loading: false,
  error: false,
  message: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case POST_NO_SHOW_BOOKING_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        message: null,
        success: false
      }
    case POST_NO_SHOW_BOOKING_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      }
    case POST_NO_SHOW_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: null,
        success: true
      }
    case POST_NO_SHOW_BOOKING_RESET:
      return {
        ...state,
        success: false
      }
    default:
      return state
  }
}
